import { ref, computed } from 'vue';

const MAX_HISTORY = 50;

export function useEditorHistory() {
  const undoStack = ref([]);
  const redoStack = ref([]);
  const isPaused = ref(false);

  function pushState(snapshot) {
    if (isPaused.value) return;
    undoStack.value.push(snapshot);
    if (undoStack.value.length > MAX_HISTORY) {
      undoStack.value.shift();
    }
    redoStack.value = [];
  }

  function undo(currentSnapshot) {
    if (undoStack.value.length === 0) return null;
    redoStack.value.push(currentSnapshot);
    return undoStack.value.pop();
  }

  function redo(currentSnapshot) {
    if (redoStack.value.length === 0) return null;
    undoStack.value.push(currentSnapshot);
    return redoStack.value.pop();
  }

  function clearHistory() {
    undoStack.value = [];
    redoStack.value = [];
  }

  function pause() {
    isPaused.value = true;
  }

  function resume() {
    isPaused.value = false;
  }

  const canUndo = computed(() => undoStack.value.length > 0);
  const canRedo = computed(() => redoStack.value.length > 0);

  return {
    pushState,
    undo,
    redo,
    clearHistory,
    pause,
    resume,
    canUndo,
    canRedo,
  };
}
